import {
  SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME,
  SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME,
  SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME,
  SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME
} from './constants';
import searchByOptions from './searchByOptions';

export const initialState = {
  searchByOptions,
  searchResult: null,
  searchValue: '',
  includePastTournaments: false
};

export const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME:
      return {
        ...state,
        includePastTournaments: payload || initialState.includePastTournaments
      };
    case SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME:
      return {
        ...state,
        searchValue: payload || initialState.searchValue
      };
    case SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME:
      return {
        ...state,
        searchResult: payload || initialState.searchResult
      };
    case SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME:
      return {
        ...state,
        searchByOptions: state.searchByOptions.map(x => searchByOptionReducer(x, {type, payload}))
      }; 
    default:
      return state;
  }
};

const searchByOptionReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME:
      return {
        ...state,
        selected: state.id === payload
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/home/reducer.js